module.exports = __webpack_public_path__ + "ffa9bb14d30fa8f8634043d7ab991575.svg";